<header class="create-form__header">
  {{ strategy.header | translate }}
</header>

<section class="create-form__body">
  <form #createForm="ngForm" (ngSubmit)="onSubmit()" class="create-form__form">
    <input
      hlmInput
      id="name"
      name="name"
      required
      autocomplete="off"
      class="create-form__input"
      [minlength]="minLength"
      [ngModel]="name()"
      (ngModelChange)="onNameChange($event)"
      [placeholder]="strategy.namePlaceholder | translate"
      [attr.aria-describedby]="nameInput.invalid && nameInput.touched ? 'name-error' : null"
      [attr.aria-invalid]="(nameInput.invalid && nameInput.touched) || null"
      #nameInput="ngModel"
    />
    @if (nameInput.touched && nameInput.invalid) {
      <small id="name-error" class="create-form__error">
        @if (nameInput.errors?.['required']) {
          {{ 'form.errors.required' | translate }}
        } @else if (nameInput.errors?.['minlength']) {
          {{ 'form.errors.minlength' | translate: { minLength } }}
        } @else if (nameInput.errors?.['serverError']) {
          {{ nameInput.errors!['serverError'] | translate }}
        }
      </small>
    }

    <div class="create-form__actions">
      <button hlmBtn type="submit" class="create-form__submit-button" [disabled]="isSubmitting()">
        <ocp-themed-icon name="checkmark.svg" mode="swap" />
        {{ strategy.createButtonLabel | translate }}
      </button>
      <button
        hlmBtn
        variant="secondary"
        type="button"
        class="create-form__cancel-button"
        [disabled]="isSubmitting()"
        (mousedown)="$event.preventDefault()"
        (click)="dialogRef?.close()"
      >
        <ocp-themed-icon name="cross.svg" />
        {{ strategy.cancelButtonLabel | translate }}
      </button>
    </div>
  </form>
</section>
